import { randomIntegers } from '../../utils/randomIntegers';
export const randomLoadingData = ({
  min = 15,
  max = 200,
  count = 30
}) => randomIntegers({
  min,
  max,
  count
});